module.exports = {"term_agreement_by_ll_owner":"房东/业主的协议条款"};